import React from 'react'
import tankImage from "../../../images/products/I.png"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/about/tank-banner.jpg'

function Tank10() {

   const values = [
    {
      number: 1,
      text: "Long lasting – Built with durable materials to ensure years of reliable use.",
    },
    {
      number: 2,
      text: "Leakproof – Designed to prevent any water leakage for complete peace of mind.",
    },
    {
      number: 3,
      text: "Lightweight – Easy to transport and install without heavy equipment.",
    },
    {
      number: 4,
      text: "Easy to install – User-friendly design that supports quick and hassle-free setup.",
    },
    {
      number: 5,
      text: "6 layers – Multiple protective layers for extra strength and temperature control.",
    },
    {
      number: 6,
      text: "Affordable – Quality you can trust at a price that fits your budget.",
    },
      {
      number: 7,
      text: "Available in various colors – Choose from a range of colors to suit your space.",
    },
      {
      number: 8,
      text: "Resistant to bacterial growth – Maintains water hygiene with anti-bacterial inner layer.",
    },
  ];

  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'10 Layer Water Tank'} pagesub={'Water Tank'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
      <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
  <h2 className="fw-bold mb-3">10 Layers. Ultimate Protection.</h2>
  <p style={{ textAlign: "justify" }}>
    For areas with harsh climate conditions, uncertain water sources, or sensitive storage needs, a 10-layer water tank offers unmatched performance. These tanks are engineered for maximum protection, insulation, and hygiene, ensuring safe water storage round the clock.
  </p>
  <p style={{ textAlign: "justify" }}>
    At SNBS, we manufacture premium 10-layer water tanks using 100% virgin, food-grade plastic. Each layer plays a crucial role—from UV protection and heat resistance to anti-bacterial inner linings and structural strength—ensuring the water remains cool, clean, and safe for consumption.
  </p>
  <p style={{ textAlign: "justify" }}>
    Available in sizes like 300L, 500L, 750L, 1000L, 1500L, and 2000L, these tanks combine quality, capacity, and cutting-edge technology. They are lightweight, durable, and easy to install—making them a reliable choice for residential, commercial, and agricultural use.
  </p>
</div>

      </div>
    </section>
 <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">10 Layer Water Tank</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="7" className="bg-primary text-white">
                Water tanks available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>300</th>
              <th>500</th>
              <th>750</th>
              <th>1000</th>
              <th>1500</th>
              <th>2000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="7" className="bg-primary text-white">
                10 Layer Water Tank Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>300</th>
              <th>500</th>
              <th>750</th>
              <th>1000</th>
              <th>1500</th>
              <th>2000</th>
            </tr>
            <tr className="table-light">
              <th>Height (mm)</th>
              <td>810</td>
              <td>956</td>
              <td>1090</td>
              <td>1255</td>
              <td>1405</td>
              <td>1540</td>
            </tr>
            <tr className="table-light">
              <th>Diameter (mm)</th>
              <td>731</td>
              <td>860</td>
              <td>980</td>
              <td>1060</td>
              <td>1220</td>
              <td>1335</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default Tank10